/***************************************************************************
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import './index.css'
import App from './App.tsx'
import Meshes from './pages/Meshes.tsx'
import MeshesAnimations from './pages/MeshesAnimations.tsx'
import SWC2 from './pages/SWC2.tsx'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter basename="/demo">
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/meshes" element={<Meshes />} />
        <Route path="/meshes-animations" element={<MeshesAnimations />} />
        <Route path="/spectrum-wc" element={<SWC2 />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)
